import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withFormik } from 'formik';
import { compose } from 'recompose';
import moment from 'moment';
import {
  TextField,
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
} from '@material-ui/core';
import { PROPOSAL_LIST_STATUS } from '../../../utils/ConstantsMain';

const styles = () => ({
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
  },
  heightSelect: {
    height: 76,
    '@media screen and (max-width: 619.98px)': {
      width: '88%',
    },
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    backgroundColor: '#fff',
    zIndex: 10,
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  TextField: {
    maxWidth: '536px',
  },
  creationInfo: {
    display: 'flex',
    marginBottom: 25,
    '& div p': {
      '&:first-child': {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#013957',
        lineHeight: 'normal',
        marginBottom: 3,
      },
      '&:last-child': {
        fontSize: 14,
        color: '#484848',
        lineHeight: 'normal',
      }
    },
    '& div:first-child': {
      marginRight: 32,
    }
  },
});

const AboutFormLawyer = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    classes,
    submitForm,
    setValidationAction,
    valuesToEdit,
    proposalData
  } = props;

  const [title, setTitle] = useState('');

  useEffect(() => {
    //setValidationAction(submitForm);
    valuesToEdit && Object.values(valuesToEdit).length > 0 && setTitle(valuesToEdit.title)
    proposalData && Object.values(proposalData).length > 0 && setTitle(proposalData.title)
  },[]);
  return (
    <form onSubmit={handleSubmit}>
      {valuesToEdit && Object.values(valuesToEdit).length ?
        <div className={classes.creationInfo}>
          <div>
            <p>ID propuesta</p>
            <p>{valuesToEdit? valuesToEdit.id : '' }</p>
          </div>
          <div>
            <p>Fecha de creación</p>
            <p>{valuesToEdit && valuesToEdit.createdAt ? moment.unix(valuesToEdit.createdAt._seconds).format('DD/MM/YYYY') : moment().format('DD/MM/YYYY')}</p>
          </div>
        </div> : null
      }
      <div className={classes.creationInfo}>
        <div>
          <p>Título o tema de la propuesta económica</p>
          <p dangerouslySetInnerHTML={{ __html: title }} />
        </div>
      </div>


      {/* <FormControl
        style={{ maxWidth: '536px' }}
        classes={{ root: classes.heightSelect }}
        variant="outlined"
        error={touched.Items && errors.Items ? true : false}
      >
        <InputLabel
          htmlFor="select-multiple-checkbox"
          classes={{
            root: classes.inputLabelRoot,
            shrink: classes.inputLabelShrink,
          }}
        >
          {'Estatus de la propuesta'}
        </InputLabel>
        <Select
          id="statusProposal"
          name="statusProposal"
          value={values.statusProposal ? values.statusProposal : []}
          onChange={handleChange}
        >
          {PROPOSAL_LIST_STATUS &&
            PROPOSAL_LIST_STATUS.map((item, index) => (
              <MenuItem key={index} value={item.value}>
                {item.name}
              </MenuItem>
            ))}
        </Select>
        {touched.Items && errors.Items ? (
          <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
            {errors.Items}
          </FormHelperText>
        ) : (
          ''
        )}
      </FormControl> */}
    </form>
  );
};

const AboutFormLawyerCompose = compose(
  withStyles(styles),
  withFormik({
    mapPropsToValues: (props) => {
      const {valuesToEdit, proposalData} = props;
      return ({
        statusProposal: valuesToEdit ? valuesToEdit.status : proposalData? proposalData.status :'',

      })
    },

    validate: (values) => {
      const errors = {};
      if (!values.titleProposal) {
        errors.titleProposal = 'Campo obligatorio*';
      }
      return errors;
    },

    handleSubmit: (values, { setSubmitting }) => {
      // setSubmitting(false);
      console.log('values proposal data', values);
    },

    displayName: 'BasicForm',
  })
)(AboutFormLawyer);

const mapStateToProps = state => ({
  authClient: state.authClient,
  valuesToEdit: state.proposalsReducer.selectedProposal,
  proposalData: state.proposalsReducer.newProposalData,
});

export default connect(mapStateToProps)(AboutFormLawyerCompose);
